// extracted by mini-css-extract-plugin
export var appear = "ArticlePreview-module--appear--war1I";
export var desc = "ArticlePreview-module--desc--BjdaJ";
export var img = "ArticlePreview-module--img--PEKYX";
export var large = "ArticlePreview-module--large--xMcLm";
export var link = "ArticlePreview-module--link--OMfwP";
export var more = "ArticlePreview-module--more--RR1JB";
export var placeholder = "ArticlePreview-module--placeholder--zKMhZ";
export var root = "ArticlePreview-module--root--tC1+N";